import React, { HTMLAttributes } from 'react';

import { Container } from './styles';

interface ProgressBarProps extends HTMLAttributes<HTMLDivElement> {
  progress: number;
  color: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  color,
  ...rest
}) => {
  return (
    <Container progress={progress} color={color} {...rest}>
      <div />
    </Container>
  );
};

export default ProgressBar;
